'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _noAuthApiClient = require('conversations-internal-clients/http/noAuthApiClient');

var _noAuthApiClient2 = _interopRequireDefault(_noAuthApiClient);

var _applyDefaults = require('./applyDefaults');

var _applyDefaults2 = _interopRequireDefault(_applyDefaults);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var noAuthApiClient = {
  post: function post(url, data) {
    return (0, _applyDefaults2.default)(_noAuthApiClient2.default.post, url, data);
  },
  put: function put(url, data) {
    return (0, _applyDefaults2.default)(_noAuthApiClient2.default.put, url, data);
  },
  get: function get(url, data) {
    return (0, _applyDefaults2.default)(_noAuthApiClient2.default.get, url, data);
  },
  getWithResponse: function getWithResponse(url, data) {
    return (0, _applyDefaults2.default)(_noAuthApiClient2.default.getWithResponse, url, data);
  },
  delete: function _delete(url, data) {
    return (0, _applyDefaults2.default)(_noAuthApiClient2.default.delete, url, data);
  }
};
exports.default = noAuthApiClient;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/http/noAuthApiClient.js
// module id = 36
// module chunks = 2 3